import apollo from 'apollo';

import { AsyncActionHandler } from 'action-handler';
import { appQuery } from 'queries';
import { fetchInstalledAppStatus } from 'actions/registry';
import { syncInstalledApps } from 'actions/gallery';
import { handleFetchError } from 'action-utils';

export default new AsyncActionHandler({
  name: 'fetch_app',
  stateProp: 'app',
  defaultState: {
    apps: {}
  },
  handler(id) {
    return async (dispatch) => {
      dispatch(syncInstalledApps({ reset: true }));

      await dispatch(fetchInstalledAppStatus(id));

      let app;
      try {
        const { data } = await apollo.query({
          query: appQuery,
          variables: { id }
        });
        app = data.app;
      } catch (error) {
        return handleFetchError(error);
      }

      return {
        app
      };
    };
  },
  reduce(state, { app }) {
    if (!app) {
      return state;
    }

    return {
      [this.stateProp]: {
        entry: app.id
      },
      apps: {
        ...state.apps,
        [app.id]: app
      }
    };
  }
});
